module.exports = __webpack_public_path__ + "fonts/Stelvio-Grotesk-Regular.0cc2c98.woff2";